// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gk-a";
export var fulfillmentFormRail = "_gk-9";
export var headerTitleRow = "_gk-c";
export var orderDetailsWrapper = "_gk-7";
export var orderLinkTrigger = "_gk-2";
export var paymentInformationGrid = "_gk-h";
export var paymentSummaryColumn = "_gk-i";
export var shipmentContainer = "_gk-b";
export var shipmentDetailsMainPane = "_gk-8";
export var shipmentNavigationCard = "_gk-5";
export var shipmentNavigationRail = "_gk-3";
export var shipmentNavigationRailHeader = "_gk-4";
export var shipmentSummaryFact = "_gk-e";
export var shipmentSummaryGrid = "_gk-d";
export var shipmentSummaryMetadataRow = "_gk-f";
export var shipmentSummaryTags = "_gk-g";
export var shipmentWorkspace = "_gk-0";
export var shipmentWorkspaceContent = "_gk-6";
export var shipmentWorkspaceHeader = "_gk-1";